import { render, staticRenderFns } from "./UnsupportViewPcBrowser.vue?vue&type=template&id=492550de&scoped=true&"
import script from "./UnsupportViewPcBrowser.vue?vue&type=script&lang=ts&"
export * from "./UnsupportViewPcBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./UnsupportViewPcBrowser.vue?vue&type=style&index=0&id=492550de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492550de",
  null
  
)

export default component.exports